import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import MatchWidgetShell from '../common/MatchWidgetShell';
import MatchScoreHero from '../common/MatchScoreHero';
import MatchEventTimeline from '../common/MatchEventTimeline';
import MatchStatsChips from '../common/MatchStatsChips';

export default function MatchEvents({
  showBranding = false,
  competitionLabel = 'Premier League',
  featuredMatch = null,
  events = [],
  goals = [],
}) {
  const m = featuredMatch || {};
  const timeline = events.length ? events : goals;

  return (
    <div>
      <MatchWidgetShell competitionLabel={competitionLabel} subtitle="Match timeline">
        <MatchScoreHero match={m} compact />
        <MatchStatsChips match={m} events={timeline} />
        <MatchEventTimeline match={m} events={timeline} />
      </MatchWidgetShell>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
